module.exports = __webpack_public_path__ + "2a68bc5ca2e65bcf707ccd1e7c58416e.woff2";